// PrintedReef coral brand mark — replaces the old 侍 kanji glyph
// everywhere it appeared (wordmarks, loading states, the Sensei badge).
// Served same-origin at /coral-mark.png (a small transparent 128px PNG,
// so it sits cleanly on the dark UI and stays light to download).
//
// Decorative by default (aria-hidden); pass `alt` for the rare case it
// needs a label. Keep any animation/spacing class (e.g. sensei-pulse,
// ob-kanji) on it — those apply to the <img> just as they did to the
// glyph; `size` sets the pixel box since font-size no longer applies.
export function CoralMark({ size = 24, className, style, alt = '' }) {
  return (
    <img
      src="/coral-mark.png"
      alt={alt}
      aria-hidden={alt ? undefined : 'true'}
      width={size}
      height={size}
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle', objectFit: 'contain', ...style }}
    />
  );
}
